export default __webpack_public_path__ + "images/E1.27b6cba.png";